import React, { useMemo, useRef } from 'react';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import './AppTopbar.css';
import { useTheme } from './context/ThemeContext';
import { environment } from '../src/pages/util/baseUrl';

export const AppTopbar = (props) => {
    const menuRef = useRef(null);
    const navigate = useNavigate();
    const { logout, user } = useAuth();
    const { darkMode, toggleDarkMode } = useTheme();

    const SERVER_URL = environment.baseUrl.replace('/api/', '');

    const userName = user?.username || 'Usuario';

    const initials = useMemo(() => {
        return userName
            .substring(0, 2)
            .toUpperCase();
    }, [userName]);

    const menuItems = useMemo(() => [
        {
            label: 'Ver perfil',
            icon: 'pi pi-user',
            command: () => navigate('/perfil'),
        },
        {
            separator: true
        },
        {
            label: 'Cerrar sesión',
            icon: 'pi pi-sign-out',
            command: () => {
                logout();
                navigate('/login');
            },
        },
    ], [navigate, logout, darkMode, toggleDarkMode]);

    const toggleMenu = (event) => {
        if (menuRef.current) {
            menuRef.current.toggle(event);
        }
    };

    return (
        <header className="app-topbar">
            <div className="topbar-left">
                <Button
                    type="button"
                    icon="pi pi-bars"
                    className="p-button-text p-button-rounded mr-2"
                    style={{ color: '#6c757d' }}
                    onClick={props.onToggleMenuClick}
                />
                <div className="logo-container">
                    <img src={"/logos/pj.png"} alt="Logo" height="40" />
                </div>
            </div>
            <div className="topbar-right">
                <div className="user-info">
                    <span className="welcome-text" style={{ color: '#6c757d', opacity: 0.8 }}>Bienvenido,</span>
                    <div className="user-name" style={{ color: '#6c757d', }}>{userName}</div>
                </div>
                <Avatar
                    image={
                        user?.profileImage
                            ? (user.profileImage.startsWith('http')
                                ? user.profileImage                      // Si ya es una URL completa (Google, Gravatar, etc.)
                                : `${SERVER_URL}${user.profileImage}`)   // Si es ruta relativa (/uploads/foto.jpg) -> usa tu baseUrl
                            : null
                    }
                    label={!user?.profileImage ? (initials || '?') : null}
                    shape="circle"
                    className="user-avatar"
                    aria-label="Avatar del usuario"
                />
                <Button
                    type="button"
                    className="p-button-text p-button-rounded menu-toggle"
                    icon="pi pi-angle-down"
                    style={{ color: '#6c757d' }}
                    onClick={toggleMenu}
                    aria-label="Abrir menú de usuario"
                />
                <Menu
                    model={menuItems}
                    popup
                    ref={menuRef}
                />
            </div>
        </header>
    );
};

